import type { KeyboardEvent as ReactKeyboardEvent } from "react";
import { useFenceStore } from "../store/fence-store";
import type { DrawingControlsProps } from "../types/components.types";
import { isPolygonClosed } from "../utils/fence.utils";

export const DrawingControls = ({
	onComplete,
	onCancel,
}: DrawingControlsProps) => {
	const {
		drawingMode,
		tempCircle,
		tempPolygon,
		isEditingFence,
		isRedrawingEdit,
	} = useFenceStore();

	if (!drawingMode) {
		return null;
	}

	const isCircleComplete = tempCircle !== null && tempCircle.radius > 0;
	const isPolygonComplete =
		tempPolygon.length >= 3 && isPolygonClosed(tempPolygon);

	const canComplete =
		(isEditingFence && !isRedrawingEdit) ||
		(drawingMode === "circle" && isCircleComplete) ||
		(drawingMode === "polygon" && isPolygonComplete);

	const getMessage = () => {
		if (drawingMode === "circle") {
			return "Clique para concluir a criação da cerca.";
		}

		if (drawingMode === "polygon") {
			return "Ligue os pontos para concluir";
		}
		return "";
	};

	const handleKeyDownAction = (e: ReactKeyboardEvent, action: () => void) => {
		if (e.key === "Enter" || e.key === " ") {
			e.preventDefault();
			action();
		}
	};

	return (
		<div className="-translate-x-1/2 fixed top-40 left-1/2 z-[1000] max-w-lg rounded-lg bg-white px-4 py-3 shadow-lg">
			<div className="flex flex-col items-stretch gap-3 sm:flex-row sm:items-center sm:gap-4">
				<span className="text-gray-700 text-sm">{getMessage()}</span>

				<div className="flex shrink-0 flex-wrap justify-end gap-2">
					<button
						aria-label={
							isEditingFence
								? "Cancelar edição da cerca"
								: "Cancelar criação da cerca"
						}
						className="rounded-md border border-gray-300 px-3 py-1.5 font-medium text-gray-700 text-sm hover:bg-gray-50"
						onClick={onCancel}
						onKeyDown={(e) => {
							handleKeyDownAction(e, onCancel);
						}}
						tabIndex={0}
						type="button"
					>
						Cancelar
					</button>

					<button
						aria-label="Concluir desenho da cerca"
						className="rounded-md bg-blue-600 px-3 py-1.5 font-medium text-sm text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-blue-600"
						disabled={!canComplete}
						onClick={onComplete}
						onKeyDown={(e) => {
							handleKeyDownAction(e, onComplete);
						}}
						tabIndex={0}
						type="button"
					>
						Concluir
					</button>
				</div>
			</div>
		</div>
	);
};
